import { Component, AfterViewInit, Renderer2, OnDestroy, OnInit, HostListener, ViewChild, ViewContainerRef, ComponentRef, ChangeDetectorRef } from '@angular/core';
import { MenuService } from '../../service/app.menu.service';
import { MessageService } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { AppComponent } from '../../../../../app.component';
import { AuthService as AirAuthService, AuthService } from '../../service/auth/auth.service';
import { FilterService } from '../../service/filter/filter.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserControlService as AirUserControlService } from '../../service/userControl/user-control.service';
import { CommonService } from '../../service/common/common.service'
import { SubSink } from "subsink";
import { NavigationService } from '../../service/navigation/navigation.service';
import { filter } from 'rxjs';
import { FilterPanelComponent } from '../filter-panel/filter-panel.component';
import { AirAppRoutes } from '../../../common/lib/air-api-constant';
import { StorageService } from '../../service';
import { DialogService } from '../../service/dialog/dialog.service';
@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    styleUrls: ['./app.main.component.scss'],
    standalone: false
})
export class AppMainComponent implements AfterViewInit, OnDestroy, OnInit {

    rotateMenuButton: boolean;

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean;

    staticMenuMobileActive: boolean;

    menuClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    documentClickListener: () => void;

    configActive: boolean;

    configClick: boolean;

    rightPanelActive: boolean;

    rightPanelClick: boolean;

    showMenu: boolean = false;

    menuHoverActive = false;

    searchClick = false;

    checked: boolean;

    firstName: string;

    lastName: string;

    companyTitle: string;

    search = false;

    companyList: any;
    keyRef: string = 'bdpReferenceNumber';
    currentKeyRef: string = 'bdpReferenceNumber';
    airKeyRef: string = '';
    displayedKeyRef: string = 'FORWARDER_REFERENCE_NUMBER';
    displayKeyRefDialog: boolean = false;
    hasUserScrolledToBottom: boolean = true;
    private subscription = new SubSink();
    displayBasic: boolean;
    showAirDisplay: boolean = true;
    logoLink: string = '/';
    logoSrc: string = 'assets/layout/images/Smart Navigator_White.png';
    logoClass: string = 'bdp-logo';
    currentComponentRef: ComponentRef<any>;
    @ViewChild('filterPanelContainer', { read: ViewContainerRef, static: true }) filterPanelContainer: ViewContainerRef;

    @HostListener('scroll', ['$event'])
    onScroll(event: any) {
        // visible height + pixel scrolled >= total height 
        if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
            this.hasUserScrolledToBottom = false;
        }
    }
    constructor(
        public renderer: Renderer2,
        private menuService: MenuService,
        private primengConfig: PrimeNG,
        public app: AppComponent,
        public storageService: StorageService,
        public airFilterService: FilterService,
        public authService: AuthService,
        public airAuthService: AirAuthService,
        public router: Router,
        private commonService: CommonService,
        private route: ActivatedRoute,
        private airUserControlService: AirUserControlService,
        private messageService: MessageService,
        private navigationService: NavigationService,
        private cdRef: ChangeDetectorRef,
        private dialogService: DialogService
    ) {

        this.showAirDisplay = true;
        // this.commonService.showAirDisplay$.subscribe(showAir => {
        //     if (showAir != null) {
        //         this.showAirDisplay = showAir = true;
        //         if (this.showAirDisplay) this.ngOnInit();
        //         else this.ngOnInit();
        //         if (this.filterPanelContainer) {
        //          //   this.loadFilterPanel();
        //         }
        //     }
        //     else if (showAir == null) {
        //         this.showAirDisplay = showAir = true;
        //         if (this.showAirDisplay) this.ngOnInit();
        //         else this.ngOnInit();
        //         if (this.filterPanelContainer) {
        //        ///     this.loadFilterPanel();
        //         }
        //     }
        // });

        this.subscription.add(
            this.airUserControlService.$userCompany.subscribe((companies: any) => {
                if (companies && companies.length) {
                    this.showMenu = true;
                } else {
                    this.showMenu = false;
                }
            }),
            this.airUserControlService.$userFeatures.subscribe((features: any) => {
                if (features == null) {
                    this.showMenu = false;
                }
            })
        );
    }

    // loadFilterPanel() {
    //     // Check if the ViewChild is defined and initialized
    //     if (!this.filterPanelContainer) {
    //         console.warn('Filter panel container not available.');
    //         return;
    //     }
    //     // Clear previous components
    //     if (this.currentComponentRef) {
    //         this.currentComponentRef.destroy();
    //     }

    //     // Load the correct component based on showAirDisplay value
    //     if (this.showAirDisplay) {
    //         this.currentComponentRef = this.filterPanelContainer.createComponent(FilterPanelComponent);
    //     }
    //     this.cdRef.detectChanges();
    // }

    ngOnInit() {
        //  console.log("ngOnInit");
        let token = this.storageService.getItem("token");
        let decodedToken = this.commonService.parseJwt(token);
        let email = '';
        let fullName = [];
        fullName = decodedToken.name.split(' ');
        this.firstName = fullName[0];
        this.lastName = fullName[1];
        this.companyTitle = decodedToken['custom:company_name'];
        email = decodedToken.email;
        if (this.showAirDisplay) {
          //  let bdpEmployee = this.airUserControlService.getUserAttribute(email);
          //  let isBDPEmployeeEnabled: boolean = bdpEmployee == null || bdpEmployee == undefined ? false : true;

            // this.airAuthService.$eula.subscribe(isEulaAccepted => {
            //     let eulaAccepted: boolean = isEulaAccepted == '0' || isEulaAccepted == null || isEulaAccepted == undefined ? false : true;
            //     if (eulaAccepted == null || eulaAccepted === true || email.includes('@psabdp.com') || email.includes('@bdpint.com') || isBDPEmployeeEnabled === true) {
            //         this.displayBasic = false;
            //     }
            //     else if (eulaAccepted != null || eulaAccepted === false || !email.includes('@psabdp.com') || !email.includes('@bdpint.com') || isBDPEmployeeEnabled === false) {
            //         this.displayBasic = true;
            //     }
            // })
            this.airAuthService.$companyList.subscribe(res => {
                if (res) {
                    this.companyList = res;
                }
            })
        }
    }
    ngAfterViewInit() {
        //    console.log("ngAfterViewInit");
        // Load the initial filter panel after the view has initialized
        //  this.loadFilterPanel();
        // hides the horizontal submenus or top menu if outside is clicked
        this.documentClickListener = this.renderer.listen('body', 'click', (event) => {
            if (!this.topbarItemClick) {
                this.activeTopbarItem = null;
                this.topbarMenuActive = false;
            }

            if (!this.menuClick && this.isHorizontal()) {
                this.menuService.reset();
            }

            if (this.configActive && !this.configClick) {
                this.configActive = false;
            }

            if (!this.rightPanelClick) {
                this.rightPanelActive = false;
            }

            if (!this.menuClick) {
                if (this.overlayMenuActive) {
                    this.overlayMenuActive = false;
                }
                if (this.staticMenuMobileActive) {
                    this.staticMenuMobileActive = false;
                }

                this.menuHoverActive = false;
                this.unblockBodyScroll();
            }

            if (!this.searchClick) {
                this.search = false;
            }

            this.searchClick = false;
            this.configClick = false;
            this.topbarItemClick = false;
            this.menuClick = false;
            this.rightPanelClick = false;
        });
        if (this.showAirDisplay) {
            //  console.log("AIR Clicked")
            this.subscription.add(this.airFilterService.$keyRef.subscribe((res: any) => {
                //     console.log("Updated key::", res);
                this.displayedKeyRef = res.keyIndex ? res.keyIndex : 1;
            },
            ));
            //   console.log('Displayed Key Reference:', this.displayedKeyRef);
        }
    }

    onMenuButtonClick(event) {
        this.rotateMenuButton = !this.rotateMenuButton;
        this.topbarMenuActive = false;
        this.menuClick = true;

        if (this.app.menuMode === 'overlay' && !this.isMobile()) {
            this.overlayMenuActive = !this.overlayMenuActive;
        }

        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        } else {
            this.staticMenuMobileActive = !this.staticMenuMobileActive;
            if (this.staticMenuMobileActive) {
                this.blockBodyScroll();
            } else {
                this.unblockBodyScroll();
            }
        }

        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        if (item.className === 'search-item topbar-item') {
            this.search = !this.search;
            this.searchClick = !this.searchClick;
        }

        event.preventDefault();
    }

    onTopbarAirSubItemClick(event, ope: string = '') {
        event.preventDefault();
        switch (ope) {
            case AirAppRoutes.User.PROFILE: {
                this.commonService.navigateRoute({
                    route: AirAppRoutes.User.PROFILE,
                    type: 'User',
                });
                break;
            }
            case AirAppRoutes.User.CHANGE_PASSWORD: {
                this.commonService.navigateRoute({
                    route: AirAppRoutes.User.CHANGE_PASSWORD,
                    type: 'User',
                });
                break;
            }
            case AirAppRoutes.User.ETA_THRESHOLD: {
                this.commonService.navigateRoute({
                    route: AirAppRoutes.User.ETA_THRESHOLD,
                    type: 'User',
                });
                break;
            }
            case AirAppRoutes.User.KEY_REFERENCE: {
                this.displayKeyRefDialog = true;
                this.setDefaultKeyRef();
                break;
            }
            // case AppRoutes.Manager.USER_CONTROL: {
            //     this.commonService.navigateRoute({
            //         route: AppRoutes.User.USER_CONTROL,
            //         type: 'User',
            //     });
            //     break;
            // }
            case AirAppRoutes.Auth.LOGOUT: {
                this.authService.logout();
                break;
            }
            case AirAppRoutes.User.RELEASE_NOTES: {
                this.commonService.navigateRoute({
                    route: AirAppRoutes.User.RELEASE_NOTES,
                    type: 'User',
                });
                break;
            }
        }
    }
    setDefaultKeyRef() {
        if(this.airKeyRef!='1'){
            return
        }
        this.airKeyRef = this.storageService.getItem('keyReference') || '1'; // Default to '1' if not set
        this.displayedKeyRef = this.airKeyRef;
        this.airUserControlService.setAirKeyReferenceSettings({
            keyReference: this.airKeyRef
        }).subscribe(response => {
            if (response.status === 200) {
                this.airFilterService.updateAirKeyRef(this.airKeyRef);
                this.storageService.setItem('keyReference', this.airKeyRef);
            }
        })
    }

    onRTLChange(event) {
        this.app.isRTL = event.checked;
    }

    onRippleChange(event) {
        this.app.ripple = event.checked;
        this.primengConfig.ripple = event.checked;
    }

    onConfigClick(event) {
        this.configClick = true;
    }

    // onRightPanelButtonClick(event) {
    //     this.rightPanelClick = true;
    //     this.rightPanelActive = !this.rightPanelActive;
    //     event.preventDefault();
    // }

    // onRightPanelClick() {
    //     this.rightPanelClick = true;
    // }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isMobile() {
        return window.innerWidth <= 640;
    }

    isOverlay() {
        return this.app.menuMode === 'overlay';
    }

    isStatic() {
        return this.app.menuMode === 'static';
    }

    isHorizontal() {
        return this.app.menuMode === 'horizontal';
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }


    setAirKeyReference(isReset: boolean = false) {
        if (isReset) {
            this.airKeyRef = '1'
        } else {
            this.displayKeyRefDialog = false;
        }
        this.displayedKeyRef = this.airKeyRef;
        const data = this.dialogService.getToasterData(false);
        data.hasUndo = false;
        //     data.content = " Key Reference Number changes have been saved.";
        //   this.dialogService.updateToasterData(data);
        this.subscription.add(
            this.airUserControlService.setAirKeyReferenceSettings({
                keyReference: this.airKeyRef
            }).subscribe(response => {
                //   console.log('API call successful', response);
                if (response.status === 200) {
                    this.airFilterService.updateAirKeyRef(this.airKeyRef);
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Key Reference Number changes have been saved.' });
                    this.storageService.setItem('keyReference', this.airKeyRef);
                } else {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save Key Reference Number changes.' });
                }
            }, error => {
                //    console.log('API call failed', error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save Key Reference Number changes.' });
            })
        );
    }

    acceptEula() {
        let requestBody: any = {
            firstName: this.firstName,
            lastName: this.lastName,
            userCompany: this.companyTitle,
            version: '1.1.2',// to be fetched from another api later.
            eulaStatus: 1
        }

        this.airUserControlService.saveUpdateAirEula(requestBody).subscribe(res => {
            if (res.status) {
                this.airAuthService.updateEula(true);
                this.displayBasic = false;
                this.messageService.add({
                    key: "emptyToster",
                    severity: 'success',
                    life: 10000,
                    summary: "The Smart EULA Terms have been Accepted.",
                    detail: "",
                });
            }
        })

    }

    rejectEula() {
        let requestBody: any = {
            firstName: this.firstName,
            lastName: this.lastName,
            userCompany: this.companyTitle,
            version: '1.1.2',// to be fetched from another api later.
            eulaStatus: 0
        }

        if (this.showAirDisplay) {
            this.airUserControlService.saveUpdateAirEula(requestBody).subscribe(res => {
                if (res.status) {
                    this.airAuthService.updateEula(true);
                    this.displayBasic = false;
                    this.messageService.add({
                        key: "emptyToster",
                        severity: 'success',
                        life: 10000,
                        summary: "The Smart EULA Terms have been declined. ",
                        detail: "Access to Smart Air is not granted. If you have any questions or concerns, contact your manager or BDP Contact.",
                    });
                }
            })
        }
    }

    ngOnDestroy() {
        if (this.documentClickListener) {
            this.documentClickListener();
        }
        // Destroy the dynamically created component if it exists
        if (this.currentComponentRef) {
            this.currentComponentRef.destroy();
        }
        this.subscription.unsubscribe();
    }
}

function onWindowScroll() {
    throw new Error('Function not implemented.');
}
//DF